module.exports = "/_next/static/images/a2a9454cff67cb388bf0bad212a64486-app-screenshots-md@3x.jpg.webp";